import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect map (#592, PARITY.md §5): `…/emails` moved to `…/subscribers`.
export const Route = createFileRoute("/dashboard/w/$workspaceId/emails")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/subscribers",
      params: { workspaceId: params.workspaceId },
    });
  },
});
